import React from 'react';
import { Col, Row } from 'reactstrap';
import strategySteps from '../../../data/mailjetTemplateKeysForStrategys';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface StrategyData {
  name: string;
  [key: string]: any;
}

interface CommonStrategyProps {
  currentStrategy: StrategyData;
  userStrategySteps?: string[];
  doStrategyStep: (step: string) => void;
}

const CommonStrategy: React.FC<CommonStrategyProps> = ({
  userStrategySteps,
  doStrategyStep,
  currentStrategy: { name }
}) => {
  if (!userStrategySteps) return null;
  const steps = strategySteps[name as keyof typeof strategySteps];
  const checked: { [key: string]: boolean } = {};
  steps.forEach((step: string) => {
    checked[step] = userStrategySteps.includes(step);
  });

  return (
    <Row>
      {Object.keys(checked).map((key, index) => (
        <Col
          key={key}
          xs="12"
          className={!checked[`${name}_${index}`] && index !== 0 ? 'text-muted' : ''}
        >
          <strong>
            {getTranslationKey('step')} {(index + 1).toString()}
          </strong>
          <div className="p-10">
            <div className="checkbox position-relative form-check">
              <label className="form-check-label">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={checked[key]}
                  disabled={
                    (index !== 0 && (!checked[`${name}_${index}`] || checked[key])) ||
                    (index === 0 && checked[key])
                  }
                  onChange={() => doStrategyStep(key)}
                />
                {getTranslationKey(`strategies.${name}.${key}`)}
              </label>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default CommonStrategy;
